import Constants from "../Constants/Constants";

const API_URL = `${Constants.BASE_URL}/api`;

const API = {
  API_URL,
  members: {
    get login() {
      return {
        url: `${API_URL}/member/login`,
        method: "POST",
      };
    },

    get validateVoucher() {
      return {
        url: `${API_URL}/member/validatevoucher`,
        method: "GET",
      };
    },

    get forgotPassword() {
      return {
        url: `${API_URL}/member/forgotpassword`,
        method: "POST",
      };
    },
    get getBuildingsByZipCode() {
      return {
        url: `${API_URL}/member/getzipcodebuildingpackage?zip=`,
        method: "GET",
      };
    },

    get openDoor() {
      return {
        url: `${API_URL}/member/opendoor`,
        method: "POST",
      };
    },

    get openGuestDoor() {
      return {
        url: `${API_URL}/member/guestopendoor`,
        method: "POST",
      };
    },

    get resetPassword() {
      return {
        url: `${API_URL}/member/resetpassword`,
        method: "POST",
      };
    },

    get extendBooking() {
      return {
        url: `${API_URL}/booking/extend`,
        method: "POST",
      };
    },

    get getBookingByGuestUuid() {
      return {
        url: `${API_URL}/member/bookingbyuuid?BookingUUid=`,
        method: "GET",
      };
    },

    get guestAmenityAccess() {
      return {
        url: `${API_URL}/member/guestamenities?guestUuid=`,
        method: "GET",
      };
    },

    get addBookingGuest() {
      return {
        url: `${API_URL}/member/addbookingguest`,
        method: "POST",
      };
    },

    get cancelBooking() {
      return {
        url: `${API_URL}/booking/cancelbooking/`,
        method: "POST",
      };
    },

    get signup() {
      return {
        url: `${API_URL}/member/register`,
        method: "POST",
      };
    },
    get signupWithoutPackage() {
      return {
        url: `${API_URL}/member/registerparking`,
        method: "POST",
      };
    },
    get profile() {
      return {
        url: `${API_URL}/member/profile`,
        method: "GET",
      };
    },

    get dashboard() {
      return {
        url: `${API_URL}/member/dashboard`,
        method: "GET",
      };
    },
    get updateProfile() {
      return {
        url: `${API_URL}/member/update-profile`,
        method: "PUT",
      };
    },

    get updatePassword() {
      return {
        url: `${API_URL}/member/update-password`,
        method: "PUT",
      };
    },

    get getUpgradePackagesList() {
      return {
        url: `${API_URL}/member/upgradablepackageslist`,
        method: "GET",
      };
    },

    get getResubscribePackagesList() {
      return {
        url: `${API_URL}/member/resubscribepackageslist`,
        method: "GET",
      };
    },

    get resubscribePackage() {
      return {
        url: `${API_URL}/member/resubscripemembership`,
        method: "POST",
      };
    },

    get upgradePackage() {
      return {
        url: `${API_URL}/member/updgradepackagesubscription`,
        method: "POST",
      };
    },

    get cancelSubscription() {
      return {
        url: `${API_URL}/member/cancelsubscription`,
        method: "POST",
      };
    },

    get addCard() {
      return {
        url: `${API_URL}/member/add-card`,
        method: "POST",
      };
    },

    get bookings() {
      return {
        url: `${API_URL}/booking/get-bookings-by-member-id`,
        method: "GET",
      };
    },

    get memberByEmail() {
      return {
        url: `${API_URL}/member/by-email`,
        method: "GET",
      };
    },

    get amenitiesList() {
      return {
        url: `${API_URL}/amenities/get-all-amenities-require-booking`,
        method: "GET",
      };
    },

    get setDefaultCard() {
      return {
        url: `${API_URL}/member/update-card-default`,
        method: "PUT",
      };
    },

    get deleteCard() {
      return {
        url: `${API_URL}/member/deletecard/`,
        method: "DELETE",
      };
    },

    get createBooking() {
      return {
        url: `${API_URL}/booking/create`,
        method: "POST",
      };
    },

    get retrypayment() {
      return {
        url: `${API_URL}/member/retrypayment/`,
        method: "POST",
      };
    },
  },
  admin: {
    get getAllGroups() {
      return {
        url: `${API_URL}/admin/group/getallgroups`,
        method: "GET",
      };
    },

    get getGroupById() {
      return {
        url: `${API_URL}/admin/group/getgroupbyid/`,
        method: "GET",
      };
    },

    get cancelBooking() {
      return {
        url: `${API_URL}/admin/cancelbooking/`,
        method: "POST",
      };
    },

    get createGroup() {
      return {
        url: `${API_URL}/admin/group/addgroup`,
        method: "POST",
      };
    },

    get updateGroup() {
      return {
        url: `${API_URL}/admin/group/updategroup/`,
        method: "PUT",
      };
    },

    get login() {
      return {
        url: `${API_URL}/admin/login`,
        method: "POST",
      };
    },

    get dashboard() {
      return {
        url: `${API_URL}/admin/dashboard`,
        method: "GET",
      };
    },
    get getAllUsers() {
      return {
        url: `${API_URL}/admin/users`,
        method: "GET",
      };
    },
    get getAllBuildings() {
      return {
        url: `${API_URL}/admin/buildings/getall`,
        method: "GET",
      };
    },

    get getAllMembers() {
      return {
        url: `${API_URL}/admin/member/getall`,
        method: "GET",
      };
    },

    get getMemberById() {
      return {
        url: `${API_URL}/admin/member/`,
        method: "GET",
      };
    },

    get deleteMemberProfile() {
      return {
        url: `${API_URL}/admin/deletememberinformation`,
        method: "POST",
      };
    },

    get getAllFutureBookings() {
      return {
        url: `${API_URL}/admin/bookings`,
        method: "GET",
      };
    },

    get getAllPastBookings() {
      return {
        url: `${API_URL}/admin/bookingreport `,
        method: "GET",
      };
    },

    get getDoorHistory() {
      return {
        url: `${API_URL}/admin/buildings/getbuildingdoorlogbyid?buildingId=`,
        method: "GET",
      };
    },

    get packageSubscriptionReports() {
      return {
        url: `${API_URL}/admin/buildings/packagesubscriptionreport`,
        method: "GET",
      };
    },

    get buildingMembersReport() {
      return {
        url: `${API_URL}/admin/buildings/buildingmemberreport`,
        method: "GET",
      };
    },

    get profitReport() {
      return {
        url: `${API_URL}/admin/buildings/ownerprofitreport`,
        method: "GET",
      };
    },

    get residentReports() {
      return {
        url: `${API_URL}/admin/buildings/residentreport`,
        method: "GET",
      };
    },

    get addMember() {
      return {
        url: `${API_URL}/admin/member/add`,
        method: "POST",
      };
    },

    get deleteAmenityByGroupId() {
      return {
        url: `${API_URL}/admin/group/deleteamenity/`,
        method: "DELETE",
      };
    },

    get deletePackageById() {
      return {
        url: `${API_URL}/admin/package/deletepackage/`,
        method: "DELETE",
      };
    },

    get updatePackageById() {
      return {
        url: `${API_URL}/admin/package/updatepackage`,
        method: "PUT",
      };
    },

    get updateAmenityByGroupId() {
      return {
        url: `${API_URL}/admin/group/updateamenity`,
        method: "PUT",
      };
    },

    get updateMember() {
      return {
        url: `${API_URL}/admin/member/update`,
        method: "PUT",
      };
    },

    get cancelMembership() {
      return {
        url: `${API_URL}/admin/cancelmemberpackagesubscription/`,
        method: "POST",
      };
    },

    get extendMembership() {
      return {
        url: `${API_URL}/admin/extendmemberpackagesubscription/`,
        method: "POST",
      };
    },

    get retryPaymentMembership() {
      return {
        url: `${API_URL}/admin/retrypayment/`,
        method: "POST",
      };
    },

    get deleteMember() {
      return {
        url: `${API_URL}/admin/deletemember/`,
        method: "DELETE",
      };
    },

    get getAllLockProviders() {
      return {
        url: `${API_URL}/admin/lockprovider/getall`,
        method: "GET",
      };
    },

    get createBuilding() {
      return {
        url: `${API_URL}/admin/buildings/createbuilding`,
        method: "POST",
      };
    },

    get getBuildingById() {
      return {
        url: `${API_URL}/admin/buildings/`,
        method: "GET",
      };
    },

    get updateBuilding() {
      return {
        url: `${API_URL}/admin/buildings/updatebuilding`,
        method: "PUT",
      };
    },

    get getAmenitiesByGroupId() {
      return {
        url: `${API_URL}/admin/group/getamenitiesbygroup?groupId=`,
        method: "GET",
      };
    },

    get getPackagesByGroupId() {
      return {
        url: `${API_URL}/admin/package/allpackagesbygroupid/`,
        method: "GET",
      };
    },

    get getAllAmenitiesRateTypes() {
      return {
        url: `${API_URL}/admin/ratetype/getall`,
        method: "GET",
      };
    },

    get getAllAmenityTypes() {
      return {
        url: `${API_URL}/admin/amenitytype/getall`,
        method: "GET",
      };
    },

    get addAmenityByGroupId() {
      return {
        url: `${API_URL}/admin/group/addamenity`,
        method: "POST",
      };
    },

    get getAllCoupons() {
      return {
        url: `${API_URL}/admin/voucher/getallvouchers`,
        method: "GET",
      };
    },

    get addCoupon() {
      return {
        url: `${API_URL}/admin/voucher/addvoucher`,
        method: "POST",
      };
    },

    get getCouponById() {
      return {
        url: `${API_URL}/admin/voucher/getvoucherbyid/`,
        method: "GET",
      };
    },

    get updateCouponById() {
      return {
        url: `${API_URL}/admin/voucher/updatevoucher`,
        method: "PUT",
      };
    },

    get inactiveCoupon() {
      return {
        url: `${API_URL}/admin/voucher/inactivevoucher/`,
        method: "PUT",
      };
    },

    get addPackageByGroupId() {
      return {
        url: `${API_URL}/admin/package/createpackage`,
        method: "POST",
      };
    },

    get uploadMembers() {
      return {
        url: `${API_URL}/admin/buildings/uploadmembercsv`,
        method: "POST",
      };
    },

    get addUser() {
      return {
        url: `${API_URL}/admin/createuser`,
        method: "POST",
      };
    },

    get editUser() {
      return {
        url: `${API_URL}/admin/updateusers`,
        method: "PUT",
      };
    },

    get deleteUser() {
      return {
        url: `${API_URL}/admin/deleteuser/`,
        method: "DELETE",
      };
    },

    get deleteBuilding() {
      return {
        url: `${API_URL}/admin/buildings/deletebuilding/`,
        method: "DELETE",
      };
    },

    get getUserById() {
      return {
        url: `${API_URL}/admin/users/`,
        method: "GET",
      };
    },
    get getMembersByBuildingId() {
      return {
        url: `${API_URL}/admin/buildings/members`,
        method: "GET",
      };
    },
    get getAllRoles() {
      return {
        url: `${API_URL}/admin/role/getallroles`,
        method: "GET",
      };
    },
  },
};

export default API;
